import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { ToursService } from '../../Services/tours.service';
import { Subscription } from 'rxjs';
import { TourDate } from '../../Models/TourDate';
import { doAnimate } from '../../Shared/app.helpers';
import { LoadingService } from '../../Services/loading.service';
import { AppComponent } from 'src/app/app.component';
import { Location } from '@angular/common';

@Component({
  selector: 'app-tours',
  templateUrl: './tours.component.html',
  // styleUrls: ['./tours.component.scss','../../../assets/css/circle.css']
  styleUrls: ['../../../assets/css/circle.css']
})
export class ToursComponent implements OnInit {
  subscription = new Subscription();
  constructor(private toursService: ToursService, private location: Location, private router: Router, private route: ActivatedRoute, public appComponent: AppComponent) { }
  eventlistdata: any = {
    btsnationalList: [],
    btsRegionalList: [],
    btsconventionList: [],
    allList: []
  };
  tourDate: TourDate;
  eventseasons: any = [];
  eventstates: any = [];
  selectedseason: any;
  eventmonthrange: any = [];
  EventFilters = {
    SeasonName: "",
    SeasonId: 0,
    EventType: "All",
    StateId: 0,
    StateName: "",
    Months: 0,
    MonthName: ""
  };
  months = [
    'January', 'February', 'March', 'April', 'May',
    'June', 'July', 'August', 'September',
    'October', 'November', 'December'
  ];
  eventType: string = 'ALL';
  isListView: boolean = true; // Default to List View
  latitude = 39.8097343; // Default map center latitude
  longitude = -98.5556199; // Default map center longitude
  zoom = 6; // Default zoom level
  markers: any[] = []; // Array to store all map markers
  url: any;
  index: any = 0;
  isLoading: boolean = false;
  mapStyles: any[] = [
    {
      elementType: 'geometry',
      stylers: [{ color: '#f5f5f5' }] // Light background
    },
    {
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }] // Hides default icons
    },
    {
      elementType: 'labels.text.fill',
      stylers: [{ color: '#616161' }] // Darker text for labels
    },
    {
      elementType: 'labels.text.stroke',
      stylers: [{ color: '#f5f5f5' }] // Matches background for text stroke
    },
    {
      featureType: 'administrative.land_parcel',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#bdbdbd' }] // Light text for administrative labels
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [{ color: '#eeeeee' }] // Subtle styling for POIs
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#757575' }] // Darker text for POI labels
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{ color: '#e5e5e5' }] // Very light greenish tone for parks
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#9e9e9e' }] // Neutral text for park labels
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ color: '#ffffff' }] // White for roads
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#757575' }] // Dark gray for arterial road labels
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{ color: '#dadada' }] // Slightly highlighted highways
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#616161' }] // Dark gray for highway labels
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{ color: '#e5e5e5' }] // Very light gray for transit
    },
    {
      featureType: 'transit.station',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#757575' }] // Neutral labels for transit stations
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#c9c9c9' }] // Light gray for water bodies
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#9e9e9e' }] // Subtle text for water labels
    }
  ];
  clusterStyles = [
    {
      url: 'assets/images/BTS_Map_Pin_1.png',
      height: 45,
      width: 125,
      textColor: 'black',
      textSize: 20,
      fontWeight: 'bold',
    }
  ];
  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
    this.route.queryParams.subscribe(params => {
      this.getseasonslist(params['seasonId'] || '');
      const path = this.router.url.split('?')[0];
      this.location.replaceState(path);
    });
  }

  getseasonslist(seasonId: string) {
    this.eventseasons = [];
    this.isLoading = true;

    this.toursService.GetSeasonlist().subscribe(seasondata => {
      if (seasondata.Response.Success && seasondata.Response.Data != null) {
        const seasonList = seasondata.Response.Data;

        seasonList.forEach(childObj => {
          childObj.current = false;
          if (childObj.Selected)
            childObj.current = true;
          this.eventseasons.push(childObj);
        });

        let selectedSeason: any;
        if (seasonId && seasonId != '') {
          selectedSeason = this.eventseasons.find(x => x.Value === seasonId);
        } else {
          selectedSeason = this.eventseasons.find(x => x.Selected);
        }

        if (selectedSeason) {
          this.EventFilters.SeasonId = selectedSeason.Value;
          this.EventFilters.SeasonName = selectedSeason.Text;
        }
        this.getstateslist();
        this.getmonth();
        this.getTourDates();
      }
    }, err => {
      console.log('Error in tour date component', err);
    });
  }

  getstateslist() {
    this.eventstates = [];
    this.eventstates.push({ 'Text': 'ALL', 'Value': 0 });
    this.isLoading = true;

    this.toursService.GetStatelist().subscribe(statedata => {
     // this.isLoading = false;
      if (statedata.Response.Success && statedata.Response.Data != null) {
        statedata.Response.Data.forEach(childObj => {
          this.eventstates.push(childObj);
        });
        this.EventFilters.StateId = 0;
        this.EventFilters.StateName = 'ALL';
      }
    }, err => {
      console.log('err in tour date component', err);
    });
  }

  getTourDates() {
    this.tourDate = new TourDate();
    this.isLoading = true;

    this.clearEventlistData();

    if (this.EventFilters.SeasonId == null && this.EventFilters.SeasonId == 0) {
      this.EventFilters.SeasonId = 0;
    }

    this.tourDate.seasonId = this.EventFilters.SeasonId;
    this.tourDate.eventType = this.eventType.toString();
    this.tourDate.stateId = this.EventFilters.StateId;
    this.tourDate.month = this.EventFilters.Months;
    //doAnimate();
    this.markers = [];
    this.subscription = this.toursService.GetTours(this.tourDate).subscribe(responce => {
      if (responce != null) {
        var res = responce.Response.Data;
        if (res.EventsList.Btsconvetion.length > 0) {
          res.EventsList.Btsconvetion.forEach(childObj => {
            var monthItem = {
              month: childObj.month,
              monthEventList: childObj.monthEventList
            };
            this.eventlistdata.btsconventionList.push(monthItem);
            this.addPinForEvent(childObj); // Add pin for this event
          });
        }
        if (res.EventsList.Btsregional.length > 0) {
          res.EventsList.Btsregional.forEach(childObj => {
            var monthItem = {
              month: childObj.month,
              monthEventList: childObj.monthEventList
            };
            this.eventlistdata.btsRegionalList.push(monthItem);
            this.addPinForEvent(childObj);
          });
        }
        if (res.EventsList.Btsnational.length > 0) {
          res.EventsList.Btsnational.forEach(childObj => {
            var monthItem = {
              month: childObj.month,
              monthEventList: childObj.monthEventList
            };
            this.eventlistdata.btsnationalList.push(monthItem);
            this.addPinForEvent(childObj);
          });
        }
      }
    }, err => {
      console.log('err in tour date component', err);
      this.isLoading = false;
    });
  }

  monthNumToName(monthnum) {
    return this.months[monthnum - 1] || '';
  }

  getmonth() {
    this.eventmonthrange.push({ 'text': 'ALL', 'value': 0 });
    this.eventmonthrange.push({ 'text': 'JANUARY', 'value': 1 });
    this.eventmonthrange.push({ 'text': 'FEBRUARY', 'value': 2 });
    this.eventmonthrange.push({ 'text': 'MARCH', 'value': 3 });
    this.eventmonthrange.push({ 'text': 'APRIL', 'value': 4 });
    this.eventmonthrange.push({ 'text': 'MAY', 'value': 5 });
    this.eventmonthrange.push({ 'text': 'JUNE', 'value': 6 });
    this.eventmonthrange.push({ 'text': 'JULY', 'value': 7 });
    this.eventmonthrange.push({ 'text': 'AUGUST', 'value': 8 });
    this.eventmonthrange.push({ 'text': 'SEPTEMBER', 'value': 9 });
    this.eventmonthrange.push({ 'text': 'OCTOBER', 'value': 10 });
    this.eventmonthrange.push({ 'text': 'NOVEMBER', 'value': 11 });
    this.eventmonthrange.push({ 'text': 'DECEMBER', 'value': 12 });
    this.EventFilters.Months = 0;
    this.EventFilters.MonthName = "ALL";
  }

  loadEvent(eventType) {
    this.eventType = eventType;
    this.getTourDates();
  }

  clearEventlistData() {
    this.eventlistdata.allList = [];
    this.eventlistdata.btsnationalList = [];
    this.eventlistdata.btsRegionalList = [];
    this.eventlistdata.btsconventionList = [];
  }

  onChangeState(event: any) {
    this.EventFilters.StateId = event.target.value;
    this.getTourDates();
  }

  onChangeSeason(event: any) {
    this.EventFilters.SeasonId = event.target.value;
    this.getTourDates();
  }

  onChangeMonth(event: any) {
    this.EventFilters.Months = event.target.value;
    this.getTourDates();
  }

  onEventdetailClick($event, eventseoname, isEventEnd) {
    $event.stopPropagation();
   
    doAnimate();
    setTimeout(() => {
      const url = `/event-details/${eventseoname}`;
      window.open(url, '_blank');
    }, 500);
  }

  setView(isList: boolean) {
    this.isListView = isList;
  }

  addPinForEvent(eventObj: any): void {
    if (eventObj.monthEventList && eventObj.monthEventList.length > 0) {
      eventObj.monthEventList.forEach((event: any) => {
        // Check if VenueList is available; if not, use EventCityLatLong
        const venueList = event.VenueList && event.VenueList.length > 0
          ? event.VenueList
          : [{ LatLong: event.EventCityLatLong, Name: `${event.City}, ${event.State}` }];

        venueList.forEach((venue: any) => {
          let latitude: number | null = null;
          let longitude: number | null = null;

          if (venue.LatLong) {
            const latLong = venue.LatLong.split(',');
            latitude = parseFloat(latLong[0]);
            longitude = parseFloat(latLong[1]);
          }

          // Ensure we have valid coordinates
          if (!latitude || !longitude) {
            //console.log(`Invalid LatLong for venue: ${venue.Name}. Skipping.`);
            return; // Skip adding the marker
          }

          // Add marker with the available coordinates
          this.addMarker(latitude, longitude, venue, event);
        });
      });
    }
  }

  addMarker(latitude: number, longitude: number, venue: any, event: any): void {
    const marker = {
      latitude,
      longitude,
      iconUrl: {
        url: '/assets/images/BTS Logo_Full Color Large_Black.png',
        scaledSize: { width: 40, height: 40 },
        anchor: { x: 25, y: 50 }, // Optional: Center the icon
      },
      showInfo: false,
      details: {
        eventName: `${event.City ? event.City + ', ' : ''}${event.Abbreviation ? event.Abbreviation + ' - ' : ''}${event.EventTypeName || ''}`,
        eventType: event.EventTypeName || '',
        startDate: event.StartDate || '',
        endDate: event.EndDate || '',
        venueDetails: `${venue.Name || ''}${venue.Address ? ', ' + venue.Address : ''}${venue.City ? ', ' + venue.City : ''}${venue.State ? ', ' + venue.State : ''}${venue.ZipCode ? ', ' + venue.ZipCode : ''}`,
        seoName: event.SeoName || '',
        isEventEnd: event.IsEventEnd || false, // Default to false if not provided
      }
    };

    // Push marker to the markers array
    this.markers.push(marker);
  }
  
  toggleInfoWindow(marker: any) {
    // Close all other info windows
    this.markers.forEach((m) => (m.showInfo = false));

    // Open the clicked marker's info window
    marker.showInfo = true;
  }
    
  
}
